import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import {useParams } from 'react-router-dom';
import axios from "axios";

export default function SurveyWelcome() {
    let { usrData } = useParams();
    const [assessment, setAssessment] = useState();
    const [subject, setSubject] = useState();
    const [totalQuestions, setTotalQuestions] = useState(0);
    const [params, setParams] = useState({});
    const navigate = useNavigate(); 

    useEffect(()=>{
        if(usrData){
            // console.log("usrData",usrData)
            getAssessmentDetails()
        }
    },[usrData])

    const getAssessmentDetails = async() => {
        await axios.get(`/api/getSurveyDetails?surveyData=${usrData}&welcome=yes`)
        .then(async function (response) {
            let result = response.data;
            if(result.success){
                setAssessment(result.data.assessment)
                setSubject(result.data.subject)
                setTotalQuestions(result.data.questions.length)
                // setQuestions(result.data.questions)
                setParams(result.data.params)
                getAssessmentAnswers(result.data.params);
            }
        })
    }

    const getAssessmentAnswers = async(params) => {
        await axios.get(`/api/getAssessmentAnswers?adminId=${params.adminId}&assessmentId=${params.assessmentId}&subjectId=${params.subjectId}&raterId=${params.raterId?params.raterId:params.subjectId}&isSelf=${params.raterId?'0':'1'}`)
        .then(async function (response) {
            let result = response.data;
            // console.log("getAssessmentAnswers result==",result.data)
            if(result.success){  
                if(result.data.length > 0){
                    navigate('/survey/'+usrData)
                }
            }
        })
    }

    const handleStart = () => {
        navigate('/survey/'+usrData)
    }

    return(       
        <>
            <div className="RgCenterAlign">
                <div className="card RgQuestionCard">
                    <Link to='/'>
                        {/* <img src={process.env.REACT_APP_BASE_URL+"assets/img/first-feedback-logo.png"} className="logo" alt="logo" /> */}
                        <img src={assessment?.logo1 || process.env.REACT_APP_BASE_URL+"assets/img/first-feedback-logo.png"} className="logo" alt="logo" />
                    </Link>
                    <hr/>
                    <div className="card-header border-0  m-auto">
                        {/* <h1>Welcome to Survey</h1>  */}
                        {/* <h4 className="subjectName">Hi {rater?.name}</h4> */}
                        <h4 className="subjectName" >Welcome to the Clearpoint 360{params?.raterId ? <> <br/> for <span>{subject.firstName}</span>.</> : <>. <br/></>} This survey consists of {totalQuestions} questions. Click next when ready.</h4>               
                        {/* <p className='mt-2'>Please take a moment to complete the survey.</p> */}
                    </div> 
                    <div className="col-md-10 offset-md-1">
                        <button type="button" className="btn btn-primary w-100" onClick={handleStart}> Start &nbsp; <span className="bi bi-chevron-right"></span></button>
                    </div>                               
                </div>   
            </div>
        </>
    )
}